var s = window.s || {};

  /***************************/
 /* 	  Common group      */
/***************************/

	s.initialTitle = document.title;
	s.dom = {};
	s.domPage = {};
	s.popupCache = {};
	s.initList = s.initList || [];
	s.tpls = s.tpls || {};
	s.paths = s.paths || {};
	s.idCntr = 0;
	s.idPrefix = "auto_id_";
	s.keyCode = {"ESCAPE": 27};
	s.supportsHistoryAPI = !!(window.history && history.pushState);

	s.getId = function(prefix) {
		return (prefix || this.idPrefix) + ++this.idCntr;
	};
	s.getLocation = function(){
		return document.location || window.location;
	};
	s.scrollToElement = function(selector, timeout){
		if (timeout !== undefined)
		{
			window.setTimeout(function(){s.scrollToElement(selector);}, timeout);
			return;
		}

		try {
			var offset = $(selector).offset();
			if (offset && offset.top)
			{
				window.scrollTo(0, offset.top - s.dom.header.height()*2);
			}
		} catch (e) {;}
	};
	s.setupPaths = function(){
		if ( ! this.basePath)
		{
			this.basePath = this.detectBasePath();
		}
		var s = this;
		$.each(this.paths, function(key, val){
			s.paths[key] = s.basePath + val;
		});

		this.tpls.ajaxLoader = this.tpls.ajaxLoader.replace('{src}', this.paths.ajaxLoader);
	};
	s.detectBasePath = function(){
		var path = $('head > link:first').attr('href');
		path = path.replace(/styles\/all\.css.*/, '');
		return path;
	};
	s.cacheElements = function(){
		this.dom.window = $(window);
		this.dom.body = $('body');
		this.dom.main = $(this.mainOptions.mainSelector);

		if ('headerSelector' in this.mainOptions)
		{
			this.dom.header = $(this.mainOptions.headerSelector);
		}

		if ('footerSelector' in this.mainOptions)
		{
			this.dom.footer = $(this.mainOptions.footerSelector);
		}

		if ('wrapperSelector' in this.mainOptions)
		{
			this.dom.ajaxLoader = $(this.tpls.ajaxLoader).prependTo($(this.mainOptions.wrapperSelector));
		}

		this.dom.popupHolder = $(this.tpls.popupHolder).appendTo(this.dom.body);
		this.dom.openedPopups = [];
		this.dom.errorPopup = $(s.tpls.errorPopup);
	};
	s.initHashAction = function(){
		var hash = s.getLocation().hash.replace(/#/g,'');
		if(hash)
		{
			this.executeHashAction(hash);
		}
	};
	s.executeHashAction = function(hash){
		if(hash)
		{
			var el = $('a[rel="'+hash+'"]');
			if (el.length) {
				el.trigger('click');
				return;
			}

			if ($('#'+hash).length)
			{
				s.scrollToElement('#'+hash);
			}
		}
	};
	s.showErrorAlert = function(message, title){
		$(".popup-content", s.dom.errorPopup).html(message);
		$(".center h2", s.dom.errorPopup).html(title || "Ошибка");
		s.openPopup(s.dom.errorPopup);
	};


  /********************/
 /*    Ajax group    */
/********************/
	s.classAjaxLoader = function(){
		var _this = this;
		var loc = s.getLocation();
		this.page = null;
		this.pageLoaded = '';
		this.url = '';
		this.hash = '';
		this.referrer = loc.pathname+loc.search+loc.hash;
		this.title = '';
		this.getHandler = function(handler_name){
			return s.ajaxHandlers[handler_name] || new s.classAjaxDefaultHandler();
		};
		this.setUrl = function(url){
			var hash = url.indexOf('#');
			if (hash > 0)
			{
				_this.hash = url.substring(hash+1, url.length);
				_this.url = url.substring(0, hash);
			}
			else
			{
				_this.hash = '';
				_this.url=url;
			}
		};
		this.getPage=function(url, options){
			options = options || {};
			if(_this.pageLoaded===false) return false;
			var handler  = _this.getHandler(options.handler);
			if(handler.pageLoaded===false) return false;
			if ( ! handler.canGetPage(url, options))
			{
				handler  = new s.classAjaxDefaultHandler();
			}
			var referrer = _this.referrer;

			_this.setUrl(url);
			_this.pageLoaded=false;
			s.closeAllPopups();

			var request = handler.getPage(_this.url, options);
			if (request)
			{
				request.done(function(msg) {
					document.title = _this.title = handler.title || options.title || s.initialTitle;
					document.title = _this.title || s.initialTitle;

					if ( ! options.popstate)
					{
						options.title = _this.title;
						history.pushState(options, _this.title, url);
					}
					try {
						handler.initScripts();
					} catch (e) {;}

					// store new referrer
					var loc = s.getLocation();
					_this.referrer = loc.pathname+loc.search+loc.hash;

					s.dom.main.triggerHandler('ajax.loaded');
				});
				request.always(function(){
					_this.pageLoaded = handler.pageLoaded;
					if ( ! _this.pageLoaded) {
						_this.pageLoaded='';
					}
				});
			}
		};
		if ( ! history.emulate)
		{
			var loc = s.getLocation();
			this.setUrl(loc.pathname+loc.search+loc.hash);
		}
		loc = null;
	};

	s.classAjaxDefaultHandler = function(){
		var _this = this;
		this.subMenu = null;
		this.subSelector = s.ajaxOptions.subSelector;
		this.container = s.ajaxOptions.container;
		this.elemToSet = s.ajaxOptions.elemToSet;
		this.loaderIndicator;
		this.requestParams = {};
		this.alignLoaderIndicator = function(){
			s.alignAjaxLoader();
		};
		this.showLoaderIndicator = function(){
			s.showAjaxLoader();
			_this.alignLoaderIndicator();
		};
		this.hideLoaderIndicator = function(){
			s.hideAjaxLoader();
			_this.alignLoaderIndicator();
		};
		this.prepareInsert=function(data){
			var start_pos = data.indexOf("<!-- ajax"+_this.subSelector+" -->"),
			end_pos = data.lastIndexOf("<!-- /ajax"+_this.subSelector+" -->");

			if (start_pos > -1 && end_pos > start_pos)
			{
				this.subMenu = data.substring(start_pos, end_pos);
			}
			else
			{
				this.subMenu = null;
			}

			// Use string parsing for perfomance
			start_pos = data.indexOf("<!-- ajax"+_this.elemToSet+" -->"),
			end_pos = data.lastIndexOf("<!-- /ajax"+_this.elemToSet+" -->");

			if (start_pos > -1 && end_pos > start_pos)
			{
				return data.substring(start_pos, end_pos);
			}
			return false;
		};
		this.beforeInsert=function(){
			// clear page dom cache
			s.domPage = {};
		};
		this.executeInsert=function(data){
			try {
				$(_this.subSelector, _this.container).html(this.subMenu);
				$(_this.elemToSet, _this.container).html(data);
			} catch (e) {;}
		};
		this.afterInsert=function(){
			;
		};
		this.showError=function(){
			s.showErrorAlert('Неправильный ответ сервера');
		};
		this.initScripts=function(url, options){
			//TODO: Check initScripts and s.initPage
			s.initPage();
			s.initSelect(this.elemToSet, this.container);
		};
		this.canGetPage=function(url, options){
			return true;
		};
		this.getPage=function(url, options){
			if(_this.pageLoaded===false) return false;
			_this.msg = null;
			_this.pageLoaded = false;
			_this.url = url;
			_this.options = options;
			return _this.loadPage(url, options);
		};
		this.loadPage=function(url, options, data){
			this.showLoaderIndicator();
			var request = $.ajax({
				url: url,
				data: $.extend({"__ajax__":"1"}, _this.requestParams, data || {}),
				type: "GET",
				async:true,
				cache:true,
				dataType: "html"
			});
			request.done(function(msg) {
				var matches = msg.match(/<title>(.*?)<\/title>/);
				if ( ! matches || ! matches[1])
				{
					matches = msg.match(/<h1>(.*?)<\/h1>/);
				}
				if (matches && matches[1])
				{
					_this.title=matches[1];
				}
				_this.pageLoaded = _this.setPageAction(msg);
			});
			request.fail(function(jqXHR, textStatus, errorThrown) {
				if (textStatus !== "abort" && jqXHR.readyState > 0)
				{
					var message = "Не удалось выполнить запрос",
						title = "Ошибка";

					if (jqXHR.status == 404)
					{
						message = "<b>Запрашиваемая страница не найдена</b>";
						title = "404 ошибка";
					}

					if (textStatus === "error")
					{
						message += "<br>[ <b>" + jqXHR.status + "</b> ]  " + errorThrown;
					}
					s.showErrorAlert(message, title);
				}
				_this.pageLoaded = '';
			});
			request.always(function(){
				_this.hideLoaderIndicator();
				if ( ! _this.pageLoaded) {
					_this.pageLoaded='';
				}
			});

			return request;
		};
		this.setPageAction=function(page){
			try {
				var data = _this.prepareInsert(page);
				if (data === false || data === null)
				{
					_this.showError();
					return '';
				}
				_this.beforeInsert();
				_this.executeInsert(data);
				_this.afterInsert();
			} catch (e) {;}

			return true;
		};
	};

	s.initAjax = function(){
		var s = this;

		$(window).on('popstate.main', function(e) {
			var loc = s.getLocation();
			var state = history.state || {};
			var url = loc.pathname + loc.search;

			if (ajaxLoader.pageLoaded === false) {
				return false;
			}

			if (url == ajaxLoader.url)
				return;

			state.popstate = true;

			ajaxLoader.getPage(url+loc.hash, state);
		});

		$(window).on('hashchange.main', function(e) {
			var hash = s.getLocation().hash.replace(/#/g,'');
			if (hash && ! s.dom.openedPopups.length)
			{
				s.executeHashAction(hash);
			}
		});

		var ajaxLoader = s.mainAjaxLoader = new s.classAjaxLoader();

		this.dom.body.on('click', 'a', function(e){
			var a = $(this);
			if (a.hasClass('not-ajax-link') || a.attr('target') === '_blank') return;
			var href = a.attr('href');
			if ( ! href || href === '#'){
				e.preventDefault();
				return false;
			}
			var loc = s.getLocation();
			href = href.replace(loc.protocol+'//'+loc.host, '');
			if (a.hasClass('ajax-link') || (href.charAt(0) === '/' && (href.indexOf('index.php') !== -1 || href.indexOf('.') === -1)))
			{
				e.preventDefault();

				if (ajaxLoader.pageLoaded === false) {
					e.stopPropagation();
					return false;
				}

				var data = { handler: a.attr('data-ajax-handler') || 'default' };
				ajaxLoader.referrer=loc.pathname+loc.search+loc.hash;
				ajaxLoader.getPage(href, data);

				return false;
			}
		});

	};
	s.alignAjaxLoader = function (){
		var img = this.dom.ajaxLoader.children('img'), win = this.dom.window;
		img.css({
			"top":((win.height() - img.height()) / 2) + win.scrollTop(),
			"left":(win.width() - img.width()) / 2
		});
	};
	s.showAjaxLoader = function (){
		this.dom.ajaxLoader.show();
		s.alignAjaxLoader();
	};
	s.hideAjaxLoader = function (){
		this.dom.ajaxLoader.hide();
	};


  /*************************/
 /*      Inputs group     */
/*************************/
	s.initInputs = function(context){
		(context || this.dom.body)
		.on('focus', 'input,textarea,select', function(e){
			if ($(this).closest('.holder').length) {
				$(this).addClass('focus text-active')
					.closest('.holder')
						.addClass('parent-active')
							.parent()
								.addClass('parent-focus');
			}
		})
		.on('blur', 'input,textarea,select', function(e){
			if ($(this).closest('.holder').length) {
				$(this).removeClass('focus text-active')
					.closest('.holder')
						.removeClass('parent-active')
							.parent()
								.removeClass('parent-focus');
			}
		})
		.on('click', '.button', function(e){
			e.preventDefault();
			e.stopPropagation();
			$(this).closest('form').trigger('submit');
		})
		;

		s.initSelect(context);
	};

	s.initSelect = function(context)
	{
		$('select', (context || this.dom.body) ).selectmenu({style:'dropdown'});
	}


  /**********************/
 /*    Popups group    */
/**********************/
	s.alignPopup = function(){
		var len = this.dom.openedPopups.length;
		if (len)
		{
			var $popup = this.dom.openedPopups[len-1],
			$win = this.dom.window,
			pos = {};

			if ($popup.is(':animated')){
				$popup.stop(true,true);
			}

			if ($popup.css('position') == 'fixed')
			{
				if ($win.height() - $popup.outerHeight() / 2 < 0){
					pos.top = 0;
				}
				else {
					pos.top = ( $win.height() - $popup.outerHeight() ) / 2;
				}
			}
			else
			{
				if ($win.height() - $popup.outerHeight() / 2  + $win.scrollTop() < 0){
					pos.top = 0;
				}
				else {
					pos.top = $win.scrollTop();
				}
			}

			pos.left = ($win.width() - $popup.outerWidth()) / 2;

			$popup.css(pos);
		}
	};

	s.fitPopupHolder = function(){
		this.dom.popupHolder.css({
			height: Math.max(this.dom.body.height(), this.dom.window.height()),
			left: 0
		})
		.children('.bg').css({
			height: $(document).height(),
			width: this.dom.window.width() + this.dom.window.scrollLeft()
		});
	};

	s.windowScroll = function(heightPopup){
		var wScroll = 0;
		if ((this.dom.window.height() - heightPopup)/2 > 0){
			wScroll = this.dom.window.scrollTop() + (this.dom.window.height() - heightPopup)/2;
		} else {
			wScroll = this.dom.window.scrollTop() + 25;
		}
		if((this.dom.popupHolder.height()-wScroll-heightPopup) < 0){
			this.dom.popupHolder.height(wScroll+heightPopup + 20);
		}
		return wScroll;
	};

	s.loadPopup = function(popupName, popupUrl, callback, args){
		if ( ! popupUrl && ! this.paths[popupName])
			return;

		popupUrl = ""+(popupUrl || "");
		args = args || [];
		var key = popupName + popupUrl;
		var s = this;

		if (this.popupCache[key])
		{
			var $popup = $(this.popupCache[key]);
			s.dom.body.append($popup);
			if (callback)
			{
				args.unshift($popup);
				callback.apply(this, args);
			}
		}
		else
		{
			$.ajax({
				url: popupUrl || this.paths[popupName],
				type: 'GET',
				dataType: 'html',
				cache: true,
				success: function(data) {
					s.popupCache[key] = data.replace(/{TPL}/g, s.basePath);
					var $popup = $(s.popupCache[key]);
					s.dom.body.append($popup);
					if (callback)
					{
						args.unshift($popup);
						callback.apply(s, args);
					}
				}
			});
		}
	};

	s.openPopup = function($popup){
		var s = this;
		$popup.on('click.closePopup', '.js-close-popup', function(e){
			e.preventDefault();
			s.closePopup();
		});

		// Set popup last in the body
		this.dom.body.append($popup);
		var len = this.dom.openedPopups.length;
		if (len === 0)
		{
			// Show popup holder
			this.fitPopupHolder();
			this.dom.popupHolder.fadeIn(200);

			this.dom.window
				.on('resize.popup', function(){
					s.fitPopupHolder();
					s.alignPopup();
				})
				.on('scroll.popup', function(){
					s.fitPopupHolder();
				})
				;
			// Bind close popup by Esc key
			$(document).on('keydown.closePopup', function(e){
				if (e.keyCode == s.keyCode.ESCAPE) {
					s.closePopup();
				}
			});
		}
		else
		{
			// Hide previos popup
			this.dom.openedPopups[len-1].fadeOut(200);
		}
		this.dom.openedPopups.push($popup);
		$popup.css('left', -9999).show();
		this.alignPopup();
		$popup.hide().fadeIn(300);

		if ('popupScripts' in s)
		{
			s.popupScripts($popup);
		}

		$popup.triggerHandler('open.popup');
		$popup = null;
	};

	s.closePopup = function($popup){

		var s = this;
		var len = this.dom.openedPopups.length;

		if ( ! len)
		{
			// No has opened popups
			return;
		}

		if ($popup)
		{
			if (this.dom.openedPopups[len-1][0] !== $popup[0])
			{
				// This popup already closed
				return;
			}
		}

		$popup = this.dom.openedPopups.pop();
		len--;

		$popup.triggerHandler('close.popup');
		$popup.off().fadeOut(200, function(){
			$(this).remove();
			var len = s.dom.openedPopups.length;
			if (len)
			{
				// Display previous popup
				s.alignPopup();
				s.dom.openedPopups[len-1].fadeIn(200);
			}
		});

		$popup = null;

		if ( ! len)
		{
			// Hide popup bg
			this.dom.popupHolder.fadeOut(200);
			// Unbind popup events from window
			this.dom.window
				.off('resize.popup')
				.off('scroll.popup');
			// Unbind close popup by Esc key
			$(document).off('keydown.closePopup');
		}
	};

	s.closeAllPopups = function(){
		var fx = $.fx.off;
		$.fx.off = true;
		while (this.dom.openedPopups.length)
		{
			this.closePopup();
		}
		$.fx.off = fx;
	};

	s.createPopup = function(content, options){
		var id = s.getId(), str = '';
		if (typeof(options) == 'string')
		{
			options = {className: options};
		}
		else if (typeof(options) != 'object')
		{
			options = {};
		}
		options = $.extend({
			id : id,
			className : '',
			title : '',
			content : content,
			loader : false,
			loaderText : '',
			center : true,
			template: '#dialogTemplate'
		}, options);

		if (options.template.charAt(0) === '#')
		{
			options.template = options.template.substring(1);
			if ( ! $.render[options.template])
			{
				var tpl = {};
				tpl[options.template] = $('#'+options.template).html();
				$.templates(tpl);
				tpl = null;
			}
		}

		str = $.render[options.template](options);

		var $popup = $(str);

		if (options.onClose && (typeof options.onClose === 'function'))
		{
			$popup.on('close.popup', options.onClose);
		}

		if (options.onOpen && (typeof options.onOpen === 'function'))
		{
			$popup.on('open.popup',options.onOpen);
		}

		if (options.autoCloseTimeout)
		{
			window.setTimeout(function(){s.closePopup();}, options.autoCloseTimeout);
		}

		s.openPopup($popup);
		$popup = null;

		return id;
	};

	s.initPopups = function(){
		var s = this;
		this.dom.popupHolder.on('click', function(e){
			e.preventDefault();
			s.closePopup();
		});

		this.dom.body.on('click', '.js-open-popup', function(e){
			e.preventDefault();
			var el = $(e.currentTarget),
				popupName = el.attr("data-popup-name"),
				popupUrl = el.attr("data-popup-url");

			if (popupName)
			{
				var callbackName = "show" + popupName.charAt(0).toUpperCase() + popupName.substr(1, popupName.length-1) + "Popup";
				callbackName = el.attr("data-popup-init") || callbackName;
				s.loadPopup(popupName, popupUrl, s[callbackName] || s.openPopup, [el]);
			}
		});
	};


  /**************************/
 /*    Ajax Forms group    */
/**************************/
	s.handlerSubmitAjaxForm = function(event){
		event.preventDefault();
		var $form = $(this);

		if ($form.hasClass('in-submit'))
			return;

		$form
			.removeClass('sended')
			.find('.common-error-msg')
				.remove();

		var url = $form.attr('data-url') || $form.attr('action');
		if (! url)
			return;

		if ( ! s.checkFormAjaxFields($form))
			return;

		var form_id = $form.attr('id');
		if ( ! form_id)
		{
			form_id = s.getId();
			$form.attr('id', form_id);
		}



		$form.addClass('in-submit');
		s.showFormAjaxLoader($form);

		var form_type = $form.attr('enctype');

		if ( $form.attr('enctype') === 'multipart/form-data' )
		{
			$form.ajaxSubmit({
				url: url,
				type: "POST",
				dataType: "json",
				cache: false,
				error: function(jqXHR, textStatus, errorThrown){
					s.processErrorAjaxFormResponse(form_id, jqXHR, textStatus, errorThrown);
					s.hideFormAjaxLoader($('#'+form_id).removeClass('in-submit'));
					$('.captcha-holder img', $form).trigger('click');
				},
				success: function(data, textStatus, jqXHR){
					s.processSuccessAjaxFormResponse(form_id, data, textStatus, jqXHR);
					s.hideFormAjaxLoader($('#'+form_id).removeClass('in-submit'));
					$('.captcha-holder img', $form).trigger('click');
				},
			});
		}
		else
		{
			$.ajax({
				url: url,
				data: $form.serializeArray(),
				type: "POST",
				dataType: "json",
				cache: false
			})
			.done(function(data, textStatus, jqXHR){
				s.processSuccessAjaxFormResponse(form_id, data, textStatus, jqXHR);
			})
			.fail(function(jqXHR, textStatus, errorThrown){
				s.processErrorAjaxFormResponse(form_id, jqXHR, textStatus, errorThrown);
			})
			.always(function(){
				s.hideFormAjaxLoader($('#'+form_id).removeClass('in-submit'));
				$('.captcha-holder img', $form).trigger('click');
			})
			;
		}


		$form = null;
	};

	s.checkFormAjaxFields = function($form){
		var errors = {}, name;

		$form.find('.holder')
			.removeClass('incorrect');

		$form.find('input:text,textarea').each(function(){
			if ($(this).val().trim() == '') {
				name = $(this).closest('.holder').attr('data-ui-name') || $(this).attr('name');
				if (name)
				{
					switch (name) {
						case 'captcha':
							errors[ name ] = 'Введите защитный код';
							break;
						default:
							errors[ name ] = 'Поле не заполнено';
					}
				}
			}
		})

		if ( ! Object.keys(errors).length)
			return true;

		s.showFormErrors($form, errors);

		return false;
	}

	s.showFormAjaxLoader = function($form){
		if (typeof $form === 'string')
		{
			$form = $('#'+$form);
		}
		var $popup = $form.closest('.popup');
		if ($popup.length)
		{
			if ( ! $popup.children('.loader'))
			{
				$popup.append(s.tpls.ajaxLoader);
			}
			$popup.children('.loader').show();
		}
		else
		{
			s.dom.ajaxLoader.show();
			s.alignAjaxLoader();
		}
	};

	s.hideFormAjaxLoader = function($form){
		if (typeof $form === 'string')
		{
			$form = $('#'+$form);
		}
		var $popup = $form.closest('.popup');
		if ($popup.length)
		{
			$popup.children('.loader').hide();
		}
		else
		{
			s.dom.ajaxLoader.hide();
		}
	};

/*
 *  dont_process -
 *  success - TRUE/FALSE
 * 	dont_hide_form
 *	dont_show_message
 *  redirect - url for redirect
 *  errors
 *
 */
	s.processSuccessAjaxFormResponse = function($form, response, textStatus, jqXHR){
		if (typeof $form === 'string')
		{
			$form = $('#'+$form);
		}

		$form.triggerHandler('request.done', [response, textStatus, jqXHR]);

		if (response.dont_process !== true)
		{
			if (response.success)
			{
				var $popup = $form.closest('.popup');

				if (response.dont_hide_form !== true)
				{
					$form.fadeOut(300);

					if ($popup.length && response.dont_show_message === true)
					{
						s.closePopup($popup);
					}
				}
				else
				{
					s.hideFormErrors($form);
					s.clearAjaxForm($form);
					$form.addClass('sended')
					.find('.article-form:not(.message-ok)')
					.fadeOut(200, function(){
						$(this).remove();
						$('.message-ok',$form)
						.show();
					});
				}

				if (response.dont_show_message !== true)
				{
					var message = response.message || 'Ваше сообщение успешно отправлено.';
					var title = response.message_title || 'Сообщение отправлено';
					var timeout = response.message_timeout;
					var onClose = null;

					if (response.redirect)
					{
						var redirect = response.redirect;
						onClose = function(){s.mainAjaxLoader.getPage(redirect);};
					}
					else
					{
						onClose = function(){if($popup.length)s.closePopup($popup);};
					}

					s.createPopup('<p>'+message+'</p>', {title: title, onClose: onClose, autoCloseTimeout: timeout});
				}
				else
				{
					if (response.redirect)
					{
						s.mainAjaxLoader.getPage(response.redirect);
					}
				}
			}
			else
			{
				s.showFormErrors($form, response.errors || {});
			}
		}

		$form = response = textStatus = jqXHR = null;
	};

	s.processErrorAjaxFormResponse = function($form, jqXHR, textStatus, errorThrown){
		if (typeof $form === 'string')
		{
			$form = $('#'+$form);
		}
		$form.triggerHandler('request.fail', [jqXHR, textStatus, errorThrown]);
		s.showFormErrors($form, {"requestError": textStatus});
	};

	s.showFormErrors = function($form, errors){
		if (typeof $form === 'string')
		{
			$form = $('#'+$form);
		}

		var common_errors = '',
			$ui_item,
			$err_el,
			$common_error_el = $form.find('.common-error-msg'),
			$ui_items = $('.holder', $form);

		$ui_items.each(function(){
			var $this = $(this),
				key = $this.attr('data-ui-name');

			if ( ! key)
			{
				key = $this.find(':input').attr('name');
				if ( ! key) return;
				$this.attr('data-ui-name', key);
			}

			if ( ! errors[key])
			{
				$this.removeClass('incorrect')
					.find('.error-msg').empty();
//				$this.find('.ui-selectmenu').removeClass('not-correct');
			}
		});

		$.each(errors, function(key, error_msg){
//			selector = ".form-ui-"+key;
			$ui_item = $ui_items.filter('[data-ui-name="'+key+'"]');
			if ($ui_item.length)
			{
				$ui_item.addClass('incorrect');
//				$ui_item.find('.ui-selectmenu').addClass('incorrect');

				$err_el = $ui_item.find('.error-msg');
				if ($err_el.length)
				{
					$err_el.text(error_msg).fadeIn(200);
				}
				else
				{
					common_errors += '<p>'+error_msg+'</p>';
				}
			}
			else
			{
				common_errors += '<p>'+error_msg+'</p>';
			}
		});

		if ( common_errors.length)
		{
			$form.children('fieldset').prepend(s.tpls.commonFormError);
			$common_error_el = $form.find('.common-error-msg');
			$common_error_el.html(common_errors);
		}

		if (common_errors.length)
		{
			$common_error_el.parent().addClass('open-note');
		}
		else
		{
			$common_error_el.parent().removeClass('open-note');
		}

		$form = $ui_item = $ui_items = $err_el = $common_error_el = errors = null;
	};

	s.hideFormErrors = function($form){
		if (typeof $form === 'string')
		{
			$form = $('#'+$form);
		}
		$form.find('.common-error-msg').remove();
		$form.find('.error-msg').hide().empty();
		$form.find('.incorrect').removeClass('incorrect');
	};

	s.clearAjaxForm = function($form){
		if (typeof $form === 'string')
		{
			$form = $('#'+$form);
		}
		$form.find(':input').val('');
	};

	s.initPageAjaxForm = function(context){
		(context || this.dom.main)
			.on('submit.ajaxForm', 'form', this.handlerSubmitAjaxForm)
			.on('change.ajaxForm', ':input', function(e){
				$(this).closest('form')
					.removeClass('incorrect')
					.find('.incorrect')
						.removeClass('incorrect');
			})
			;
		context = null;
	};








  /***********************/
 /*    Captcha group    */
/***********************/

	s.initPageCaptcha = function(context){
		context = context || this.dom.main;

		var img = (context).find('.captcha-holder img');
		if (img.length)
		{
			img.on('click.captcha', function(e){
				$(e.currentTarget).attr("src", s.getCaptchaUrl());
			})

			img.attr("title", "Кликни, чтобы обновить код");

			var src = img.attr('src');
			if (src == '#'  || src.indexOf('0.gif') != -1)
			{
				img.attr("src", s.getCaptchaUrl());
			}
		}
	};





















